import {CREATE_GROUP_POST_START} from "../../types";

export const create_group_posts = (payload) => ({
    type: CREATE_GROUP_POST_START,
    payload,
});
